export default __webpack_public_path__ + "static/media/bca-raffle-arrow-right.2054a6cd.png";